import { ApiSet, BaseResponse, usePutApi } from 'utils/network/api_hooks'
import { Form } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PcrRunProbesForm } from 'entities/pcr_run'

export function usePutPcrRunProbesApi(): ApiSet<BaseResponse> & { execute: (form: Form<PcrRunProbesForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, PcrRunProbesForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<PcrRunProbesForm[]>) => {
        const apiPath = `pcr_run_probes/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
